<template>
  <m-geo-box geo-option="state" title="State List">
       <m-geo-state v-if="isMobile" :geoType="2"></m-geo-state>
     <m-geo-state-box v-else :geoType="2"></m-geo-state-box>
  </m-geo-box>
</template>

<script>
  import MGeoState from '@/components/geo/MGeoState'
  import MGeoBox from '@/components/geo/MGeoBox'
  import MGeoStateBox from '@/components/geo/MGeoStateBox'
  export default {
    components: {
      MGeoState,
      MGeoBox,
      MGeoStateBox
    },
    data () {
      return {
      }
    },
    computed: {
      isMobile () {
        return this.$store.state.config.isMobile
      }
    }
  }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/order/GeoState.vue